import type { Theme } from '../../types/theme';

export const vercelTheme: Theme = {
  id: 'vercel',
  name: 'Vercel',
  description: 'Black and white precision design with Geist font. Extreme negative tracking and shadow-as-border technique.',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/vercel/DESIGN.md',
  visualKeywords: ['monochrome', 'precision', 'Geist font', 'shadow borders', 'developer-focused', 'minimal'],
  colors: {
    background: '#ffffff',
    surface: '#fafafa',
    surfaceElevated: '#ffffff',
    surfaceDark: '#171717',
    textPrimary: '#171717',
    textSecondary: '#4d4d4d',
    textMuted: '#666666',
    border: '#e0e0e0',
    borderSubtle: '#ebebeb',
    primary: '#171717',
    primaryHover: '#000000',
    primaryActive: '#000000',
    accent: '#0072f5',
    onPrimary: '#ffffff',
    success: '#10b981',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Geist, -apple-system, BlinkMacSystemFont, sans-serif',
    bodyFont: 'Geist, -apple-system, BlinkMacSystemFont, sans-serif',
    monoFont: '"Geist Mono", ui-monospace, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-2.4px',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '12px',
    badge: '9999px',
    input: '6px',
  },
  shadow: {
    card: '0 0 0 1px rgba(0,0,0,0.08), 0 2px 2px rgba(0,0,0,0.04)',
    elevated: '0 0 0 1px rgba(0,0,0,0.08), 0 8px 8px rgba(0,0,0,0.04)',
    button: '0 0 0 1px rgba(0,0,0,0.08)',
    none: 'none',
  },
  layout: {
    maxWidth: '1200px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '56px',
  },
  mood: {
    density: 'low',
    tone: 'developer-centric, infrastructure-focused, compiler-like',
    productFit: ['Deployment platforms', 'Infrastructure tools', 'Developer APIs', 'Frontend frameworks'],
    bestFor: ['Developer tools', 'Infrastructure products', 'Technical platforms'],
    notGoodFor: ['Consumer apps', 'Healthcare', 'Finance', 'Education platforms'],
  },
};
